const Genesis = require("../Genesis.js")
import { PreLoadHelper } from '../Helpers/helpers';
import 'jquery-ui';
import ko from 'knockout';
let AutoComplete = require("./assetEdit.js");
import flatpickr from "flatpickr";
import { BlockPageHelper } from '../Helpers/helpers';
import confirmDatePlugIn from "flatpickr/dist/plugins/confirmDate/confirmDate";
import { CategoryPathComponent } from '../Shared/CategoryPath/CategoryPathComponent';
import { Modal } from 'bootstrap';
import { string32 } from 'pdfjs-dist/types/src/shared/util';
import { ISiteMobileAssetSearchAssetPage } from './ISiteMobileAssetSearchAssetPage';
import { QRCodeScanner } from "../Components/QRCodeScanner";

export class ISiteMobileAssetEditAssetPage {

    private category: CategoryPathComponent = new CategoryPathComponent({
        ModalId: 'classificationModal',
        Url: Genesis.url('/Asset/_CategoryPath'),
        PathId: 'categoryPath',
        SelectButtonId: 'selectCategoryButton',
        IsReadOnly: false,
        PreventParentSelection: true,
        AllowMultiSelect: false,
        IsRequired: true,
        FormId: "AssetForm"
    });
    private readonly idConfirmModal = document.getElementById("confirmPopulateQRCode-modal");
    private confirmModal: Modal | null = null;
    private readonly idConfirmYes = $("#idConfirmYes");
    private qrCodeScanner: QRCodeScanner | null = new QRCodeScanner;

    constructor() {
        if (this.idConfirmModal !== null) {
            this.confirmModal = new Modal(this.idConfirmModal, { backdrop: 'static', keyboard: false });
        }
    }
    public Init() {


        AutoComplete();

        $("#classificationModal").detach().appendTo("#modalContainerPlaceholder");
        ko.applyBindings(this.category);

        $('#AssetForm').off('submit');
        $("#AssetForm").submit((e: any) => {
            BlockPageHelper.block();
            const form = e.target;
            if (form !== null) {
                this.validateAutoComplete(form, "propertySearch", "RelatedProperty");
                this.validateDropDown(form, "AssetTypeID");
                this.validateDropDown(form, "StatusID");
                this.category.validateCategorySelected();
                if (!form.checkValidity()) {
                    form.classList.add('was-validated');
                    BlockPageHelper.unblock();
                    return false;
                }
            }
        });

        const today = new Date();
        const dateConfig: any = {
            dateFormat: "d/m/Y",
            enableTime: true,
            minDate: today,
            time_24hr: true,
            defaultDate: today,
            "plugins": [confirmDatePlugIn({
                confirmIcon: "<i class='fa fa-check'></i>",
                confirmText: "OK ",
                showAlways: true,
                theme: "dark"
            })]
        };
        flatpickr("#InstallationDate", dateConfig);
        flatpickr("#WarrantyExpiryDate", dateConfig);

        var scannedCode = localStorage.getItem('ScannedCode');
        var that = this;
        if (scannedCode !== null) {
            this.idConfirmYes.click(function () {
                if (scannedCode != null) {
                    $("#AssetTag").val(scannedCode);
                    localStorage.removeItem('ScannedCode');
                }
                that.confirmModal?.hide();
            });

            this.confirmModal?.show();
        }
        $("#idScanAssetTag").click(async function () {
            await that.qrCodeScanner?.startScanning();
            const scannedCode = await that.qrCodeScanner?.scanBarcodeOrQRCode();
            if (scannedCode != null)
                $("#AssetTag").val(scannedCode);
            await that.qrCodeScanner?.stopScanning();
        });

        $("#idConfirmNo").click(async function () {
            that.confirmModal?.hide();
        });

        $('#modal-Scanner .modal-header a[data-bs-dismiss="modal"]').click(function () {
            that.qrCodeScanner?.stopScanning();
        });
    }

    private validateAutoComplete(form: any, searchField: string, idField: string) {
        const search = form.elements[searchField];
        const id = form.elements[idField];
        if (search !== null) {
            search.setCustomValidity('');
            if (id.value === '0') {
                search.setCustomValidity('invalid');
                search.classList.add("invalid");
            }
        }
    }

    private validateMonth(form: any, idField: string) {
        const id = form.elements[idField];
        if (id.value != 0 && id.value > 11) {
            id.setCustomValidity('invalid');
            id.classList.add("invalid");
        }
    }

    private validateDropDown(form: any, idField: string) {
        const id = form.elements[idField];
        if (id != undefined && id.value === '0') {
            id.setCustomValidity('invalid');
            id.classList.add("invalid");
        }
    }
};